<template>
  <div>
    <h1>Aufbau und Funktion des menschlichen Ohrs</h1>

    <div align="center">
      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%">
        <img class="card-img-top" src="@/assets/Uebersicht_Ohr.jpg" alt="Card image cap">
        <h5 class="card-title">Über dieses Modul</h5>
        <div class="card-body">
         Dieses Kapitel dient als Einstieg in den Prozess des menschlichen Hörvorgangs. 
         Im Folgenden werden Aufbau und Funktion einzelner Bestandteile des Ohrs erläutert 
         und mithilfe von interaktiven Aufgaben überprüft. Dabei wird auf die einzelnen Abschnitte 
         des Ohrs eingegangenen: das Außenohr, Mittelohr sowie das Innenohr, von außen nach innen also. 
         Abschließend wird ein Bezug zu den weiteren Stationen im Hörprozess geschaffen. 
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stylez: "btn btn-secondary",
    };
  },
  toggle() {
    this.stylez = "btn btn-primary";
  },
};
</script>

<style>

</style> 
